import "./App.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.min.js";
import {
  Route,
  createBrowserRouter,
  createRoutesFromElements,
  RouterProvider,
} from "react-router-dom";
import { ForgotPasswordPage } from "./pages/ForgotPassword/ForgotPassword";
import { LoginPage } from "./pages/LoginPage/LoginPage";
import { RegistrationPage } from "./pages/RegistrationPage/RegistrationPage";
import { CashTillForm } from "./forms/CashTillForm/CashTillForm";
import CreditOfficerForm from "./forms/CreditOfficerForm/CreditOfficerForm";
import GenerateDepositSummaryReportForm from "./forms/GenerateDepositSummaryReportForm/GenerateDepositSummaryReportForm";
import GenerateManagementReportForm from "./forms/GenerateManagementReportForm/GenerateManagementReportForm";
import GenerateWithdrawalSummaryReportForm from "./forms/GenerateWithdrawalSummaryReportForm/GenerateWithdrawalSummaryReportForm";
import LocationForm from "./forms/LocationForm/LocationForm";
import UserTransactionLimitForm from "./forms/UserTransactionLimitForm/UserTransactionLimitForm";
import {
  AccountGroupForm,
  AccountGroupListing,
} from "./pages/AccountGroup/AccountGroupListing";
import { AccountListingPage } from "./pages/AccountListing/AccountListing";
import {
  AccountMarketerForm,
  AccountMarketers,
} from "./pages/AccountMarketers/AccountMarketers";
import {
  AccountOfficerForm,
  AccountOfficers,
} from "./pages/AccountOfficers/AccountOfficers";
import { AccountStatement } from "./pages/AccountStatement/AccountStatement";
import {
  AccountTypeForm,
  AccountTypeListingPage,
} from "./pages/AccountTypeListing/AccountTypeListing";
import { BalanceEnquiry } from "./pages/BalanceEnquiry/BalanceEnquiry";
import {
  ChargeListingPage,
  ChargeSetupForm,
} from "./pages/ChargeListingPage/ChargeListingPage";
import ConfigureApproval from "./pages/ConfigureApproval/ConfigureApproval";
import { CreditOfficersListingPage } from "./pages/CreditOfficersListingPage/CreditOfficersListingPage";
import { CustomerListing } from "./pages/Customers/CustomerListing";
import {
  DepositForm,
  DepositListingPage,
} from "./pages/DepositListingPage/DepositListingPage";
import { FixedDepositListingPage } from "./pages/FixedDepositListingPage/FixedDepositListingPage";
import { FundTransferListingPage } from "./pages/FundTransferListingPage/FundTransferListingPage";
import { LoanListingPage } from "./pages/LoanListingPage/LoanListingPage";
import LoanReportMasterPage from "./pages/LoanReportMasterPage/LoanReportMasterPage";
import LoanSummaryReportPage from "./pages/LoanSummaryReportPage/LoanSummaryReportPage";
import LocationListingPage from "./pages/LocationListingPage/LocationListingPage";
import MainApp from "./pages/MainApp/MainApp";
import OverDraftListingPage, {
  OverDraftForm,
} from "./pages/OverDraftListingPage/OverDraftListing";
import ReportListingPage from "./pages/ReportListingPage/ReportListingPage";
import { RoleListingPage } from "./pages/RoleListingPage/RoleListingPage";
import RoleTransactionLimitPage from "./pages/RoleTransactionLimitPage/RoleTransactionLimitPage";
import SettingsPage from "./pages/SettingsPage/SettingsPage";
import { TellerListingPage } from "./pages/TellerListingPage/TellerListingPage";
import { TransactionListingPage } from "./pages/TransactionListingPage/TransactionListingPage";
import {
  UserListingPage,
  UserRegistrationForm,
} from "./pages/UserListing/UserListingPage";
import { WithdrawalListingPage } from "./pages/WithdrawalListingPage/WithdrawalListingPage";
import NotFoundPage, { ErrorPage } from "./pages/NotFoundPage/NotFoundPage";

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route>
      <Route path="/" element={<MainApp />}>
        {/* Accounts */}
        <Route path="accounts" element={<AccountListingPage />} />

        <Route path="account-types" element={<AccountTypeListingPage />} />
        <Route path="account-type" element={<AccountTypeForm />} />
        <Route path="account-groups" element={<AccountGroupListing />} />
        <Route path="account-group" element={<AccountGroupForm />} />
        <Route path="balance-enquiry" element={<BalanceEnquiry />} />
        <Route path="account-statement" element={<AccountStatement />} />
        <Route path="account-officers" element={<AccountOfficers />} />
        <Route path="account-officer" element={<AccountOfficerForm />} />
        <Route path="account-Marketers" element={<AccountMarketers />} />
        <Route path="account-marketer" element={<AccountMarketerForm />} />
        {/* End Accounts */}

        <Route path="customers" element={<CustomerListing />} />

        {/* Begin Transactions */}
        <Route path="transactions" element={<TransactionListingPage />} />
        {/* <Route path="transactions/:transactionId" element={<TransactionListingPage />} /> */}
        <Route
          path="charges"
          element={<ChargeListingPage />}
          errorElement={<ErrorPage />}
        />
        <Route path="charge" element={<ChargeSetupForm />} />
        <Route path="deposits" element={<DepositListingPage />} />
        <Route path="deposit" element={<DepositForm />} />
        <Route path="withdrawals" element={<WithdrawalListingPage />} />
        <Route path="cash-till" element={<CashTillForm />} />
        <Route path="fund-transfers" element={<FundTransferListingPage />} />
        <Route path="fixed-deposits" element={<FixedDepositListingPage />} />
        {/* End Transactions */}

        {/* Begin Loans */}
        <Route path="loans" element={<LoanListingPage />} />
        <Route path="over-draft" element={<OverDraftListingPage />} />
        <Route path="overdraft" element={<OverDraftForm />} />
        <Route path="credit-officers" element={<CreditOfficersListingPage />} />
        <Route path="credit-officer" element={<CreditOfficerForm />} />

        <Route path="reports" element={<ReportListingPage />} />
        <Route path="loan-report" element={<LoanReportMasterPage />}>
          <Route path="summary" element={<LoanSummaryReportPage />} />
        </Route>
        {/* End Loans */}

        {/* Begin Users */}
        <Route path="users" element={<UserListingPage />} />
        <Route
          path="users/transation-limit/:id"
          element={<UserTransactionLimitForm />}
        />
        <Route path="roles" element={<RoleListingPage />} />
        <Route
          path="roles/transaction-limit"
          element={<RoleTransactionLimitPage />}
        />
        <Route path="tellers" element={<TellerListingPage />} />
        {/* End Users */}

        <Route
          path="management-report"
          element={<GenerateManagementReportForm />}
        />
        <Route
          path="deposit-summary"
          element={<GenerateDepositSummaryReportForm />}
        />
        <Route
          path="Withdrawal-summary"
          element={<GenerateWithdrawalSummaryReportForm />}
        />

        <Route path="settings" element={<SettingsPage />}></Route>
        <Route path="settings/locations" element={<LocationListingPage />} />
        <Route path="settings/location" element={<LocationForm />} />
        <Route
          path="settings/configure-approvals"
          element={<ConfigureApproval />}
        />

        <Route path="*" element={<NotFoundPage />} />
      </Route>
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/registration" element={<RegistrationPage />} />
    </Route>
  )
);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
